import React, { useEffect, useState } from 'react';
import { useI18n } from '../../../i18n/i18nService'; // Assurez-vous que i18n est correctement configuré
import DataTable from '../../../components/common/DataTable';
import { useIdentification } from '../../../contexts/IdentificationContext';
import { ButtonCustom, FormError, Modal, InputField, SelectField, TextAreaField, FieldsetGroup, FormSuccess } from '../../../components/common/Form';
import { languages } from '../../../components/LanguageSelector'
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/solid';

const EspeceFormModal = ({ open, onClose, item, onSubmit, isLoading }) => {
    const { t } = useI18n("identification");
    // const isEditMode = !!item;
    const [formData, setFormData] = useState({
        libelle: '',
        code: '',
        codeLength: ''
    });
    const [error, setError] = useState(null);


    // eslint-disable-next-line
    useEffect(() => {
        if (!!item && item) {
            setFormData({
                libelle: item.libelle || '',
                code: item.code || '',
                codeLength: item.codeLength || '',
            });
        } else {
            setFormData({ libelle: '', code: '', codeLength: '' });
        }
    }, [item]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((data) => ({ ...data, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await onSubmit(formData, !!item);
            onClose();
        } catch (err) {
            setError(t(`identification:administration.especes.error_codes.${err.status}`));
        }
    };
    return (
        <Modal open={open} onClose={onClose} title={!!item ? t('identification:administration.especes.edit') : t('identification:administration.especes.add')}>
            <form onSubmit={handleSubmit} className="space-y-4">
                {error && <FormError message={error || 'Unknow error'} />}
                <InputField
                    name="libelle"
                    label={t('identification:administration.especes.name')}
                    value={formData.libelle}
                    onChange={handleChange}
                    required
                />
                <InputField
                    name="code"
                    label={t('identification:administration.especes.code')}
                    value={formData.code}
                    onChange={handleChange}
                    required
                />
                <InputField
                    name="codeLength"
                    label={t('identification:administration.especes.code_length')}
                    type="number"
                    value={formData.codeLength}
                    onChange={handleChange}
                />
                <div className="flex justify-end space-x-2">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400">
                        {t('cancel')}
                    </button>
                    <ButtonCustom type="submit" variant='primary' className="px-4 py-2" loading={isLoading}>
                        {t('save')}
                    </ButtonCustom>
                </div>
            </form>
        </Modal>
    );
};


const TranslateModal = ({ open, onClose, item, onSubmit, isLoading }) => {
    const { t } = useI18n("identification");
    const { error } = useIdentification();
    const [formData, setFormData] = useState({
        especeId: '',
        lang: '',
        libelle: '',
        description: ''
    });
    const [editMode, setEditMode] = useState(false);
    const [success, setSuccess] = useState(false);

    // Remplir le formulaire si un item est fourni
    useEffect(() => {
        if (item) {
            setFormData({
                especeId: item.id ?? '',
                lang: '',
                libelle: '',
                description: ''
            });
            setSuccess(false);
        }
        setEditMode(false);
    }, [item]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleEdit = (item) => {
        setFormData({
            especeId: item.id ?? '',
            lang: item.lang ?? '',
            libelle: item.libelle ?? '',
            description: item.description ?? ''
        });
        setSuccess(false);
        setEditMode(true);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editMode) {
                await onSubmit(formData, 'edit');
            } else {
                await onSubmit(formData, 'add');
            }
            setSuccess(true);
            setFormData(prev => ({ ...prev, libelle: '', description: '' }));
        } catch (err) {
            console.log(err)
        }
    };

    return (
        <Modal open={open} onClose={onClose} title={t('administration.translate.title')}>
            <div className="space-y-6">
                {/* 📋 Table des traductions */}
                <table className="w-full border text-xs">
                    <thead className="bg-gray-100 dark:bg-gray-800">
                        <tr>
                            <th>#</th>
                            <th>{t('administration.translate.key')}</th>
                            <th>{t('administration.translate.lang')}</th>
                            <th>{t('administration.translate.libelle')}</th>
                            <th>{t('administration.translate.description')}</th>
                            <th>{t('administration.translate.actions')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {item?.translations?.map((translation, index) => (
                            <tr key={translation.id} className="border-t">
                                <td className="px-2 py-1">{index + 1}</td>
                                <td className="px-2 py-1">{item.libelle}</td>
                                <td className="px-2 py-1">{translation.lang}</td>
                                <td className="px-2 py-1">{translation.libelle}</td>
                                <td className="px-2 py-1">{translation.description}</td>
                                <td className="px-2 py-1">
                                    <button className="text-blue-500 hover:underline" onClick={() => handleEdit(translation)}>
                                        <PencilSquareIcon className="h-5 w-5" />
                                    </button>
                                    <button className="text-red-500 hover:underline" onClick={() => onSubmit(translation, 'delete')}>
                                        <TrashIcon className="h-5 w-5" />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* 📄 Formulaire */}
                <form onSubmit={handleSubmit} className="space-y-4">
                    {error.especes && <FormError message={error.especes} />}
                    {success && <FormSuccess message={t('administration.translate.success')} />}
                    <FieldsetGroup
                        legend={t('administration.translate.add_new')}
                        // description={t('administration.translate.add_new_description')}
                        error={error.especes}
                    >
                        <SelectField
                            name="lang"
                            label={t('administration.translate.lang')}
                            value={formData.lang}
                            onChange={handleChange}
                            required
                            options={languages.map(lang => ({ value: lang.code, label: lang.label }))}
                            placeholder={t('administration.translate.select_lang')}
                        />

                        <InputField
                            name="libelle"
                            label={t('administration.translate.libelle')}
                            value={formData.libelle}
                            onChange={handleChange}
                            required
                        />

                        <TextAreaField
                            name="description"
                            label={t('administration.translate.description')}
                            value={formData.description}
                            onChange={handleChange}
                        />
                    </FieldsetGroup>
                    <div className="flex justify-end space-x-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
                        >
                            {t('cancel')}
                        </button>
                        <ButtonCustom type="submit" disabled={isLoading} isLoading={isLoading}>
                            {t('save')}
                        </ButtonCustom>
                    </div>
                </form>
            </div>
        </Modal>
    );
};




const Espece = () => {
    const { t } = useI18n("identification");
    const {
        resources,
        loading,
        error,
        setError,
        // fetchResourceData,
        addResourceData,
        updateResourceData,
        deleteResourceData,
        addRessouceTranslationData,
        updateRessourceTranslationData,
        deleteRessourceTranslationData
    } = useIdentification(); // Assurez-vous que useIdentification est correctement importé
    const [openModal, setOpenModal] = useState(false);
    const [activeItem, setActiveItem] = useState(null);
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [translateOpen, setTranslateOpen] = useState(false)


    const especes = resources['espece'] || [];

    const handleAdd = () => {
        setActiveItem(null); // Mode ajout
        setError(prev => ({ ...prev, especes: null }))
        setOpenModal(true);
    };

    const handleEdit = (item) => {
        setActiveItem(item); // Mode édition
        setError(prev => ({ ...prev, especes: null }))
        setOpenModal(true);
    };

    const handleTranslate = (item) => {
        setActiveItem(item); // Mode édition
        setTranslateOpen(true);
        setError(prev => ({ ...prev, especes: null }))
    }

    const handleDelete = (item) => {
        setActiveItem(item);
        setError(prev => ({ ...prev, especes: null }))
        setConfirmDeleteOpen(true);
    };


    const handleCloseModal = () => {
        setOpenModal(false);
        setActiveItem(null);
    };

    const handleCancelDelete = () => {
        setConfirmDeleteOpen(false);
    };


    const handleFormSubmit = async (formData, isEditMode) => {
        if (isEditMode) {
            // console.log(activeItem)
            await updateResourceData('espece', activeItem.id, formData);
        } else {
            await addResourceData('espece', formData);
        }
    };

    const handleConfirmDelete = async () => {
        try {
            await deleteResourceData('espece', activeItem.id);
            setConfirmDeleteOpen(false);
            setActiveItem(null);
        } catch (error) {
            setError(prev => ({ ...prev, especes: t(`identification:administration.especes.error_codes.${error.status}`) }))
        }

    }

    const handleTranslationSubmit = async (formData, action) => {
        try {
            switch (action) {
                case 'add':
                    await addRessouceTranslationData('espece', formData.especeId, formData);
                    break;
                case 'edit':
                    await updateRessourceTranslationData('espece', formData.especeId, formData);
                    break;
                case 'delete':
                    await deleteRessourceTranslationData('espece', formData.id);
                    break;
                default:
                    break;
            }
            setTranslateOpen(false);
            setActiveItem(null);
        } catch (error) {
            setError(prev => ({ ...prev, especes: t(`administration.translate.errors.${error.status}`) }))
        }
    }


    const columns = [
        {
            label: 'name',
            key: 'libelle',
            headerName: t('identification:administration.especes.name'),
            width: 200,
            render: (row) => (
                <span className="">{row.translations?.[0]?.libelle ?? row.libelle}</span>
            )
        },
        {
            label: 'code',
            key: 'code',
            headerName: t('identification:administration.especes.code'),
            width: 80
        },
        {
            label: 'code Length',
            key: 'codeLength',
            headerName: t('identification:administration.especes.code_length'),
            width: 80
        },
        {
            label: 'description',
            key: 'description',
            headerName: t('identification:administration.especes.description'),
            width: 300,
            render: (row) => (
                <span className="">
                    {(row.translations?.[0]?.description) ?? row.description ?? '-'}
                </span>
            )
        },
        {
            label: 'actions',
            headerName: t('actions'),
            key: 'actions',
            width: 150,
            render: (params) => (
                <div className="flex space-x-2">
                    <button className="text-blue-500 hover:underline" onClick={() => handleEdit(params)}>
                        {t('edit')}
                    </button>
                    <button className="text-green-500 hover:underline" onClick={() => handleTranslate(params)}>
                        {t('translate')}
                    </button>
                    <button className="text-red-500 hover:underline" onClick={() => handleDelete(params)}>{t('delete')}</button>
                </div>
            )
        },
    ];
    return (
        <div>
            <DataTable title={t('identification:administration.especes.title')} columns={columns} data={especes} isLoading={loading.fetching.especes} error={error.especes}>
                {/* Vous pouvez ajouter ici des actions supplémentaires ou des composants spécifiques */}
                <div className="flex justify-end mb-4">
                    <button onClick={handleAdd} className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
                        {t('identification:administration.especes.add')}
                    </button>
                </div>
            </DataTable>
            {openModal && (
                <EspeceFormModal
                    open={openModal}
                    onClose={handleCloseModal}
                    item={activeItem} // null pour ajout, objet pour modification
                    onSubmit={(formData, isEditMode) => handleFormSubmit(formData, isEditMode)}
                    isLoading={loading.mutation.especes}
                />
            )}
            {confirmDeleteOpen && (
                <Modal open={confirmDeleteOpen} onClose={handleCancelDelete} title={t('identification:administration.especes.confirm_delete_title')}>
                    <div className="space-y-4">
                        {error.especes ?
                            <FormError message={error.especes} /> :
                            <p className='text-light-text dark:text-dark-text font-normal text-sm'>{t('identification:administration.especes.confirm_delete_message')}</p>
                        }
                        <div className="flex justify-end space-x-2">
                            <button onClick={handleCancelDelete} className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400">
                                {t('cancel')}
                            </button>
                            <ButtonCustom onClick={handleConfirmDelete} variant="danger" className="px-4 py-2" loading={loading.mutation.especes}>
                                {t('confirm')}
                            </ButtonCustom>
                        </div>
                    </div>
                </Modal>
            )}
            {translateOpen &&
                <TranslateModal
                    open={translateOpen}
                    onClose={() => setTranslateOpen(false)}
                    item={activeItem}
                    onSubmit={(formData, isEdit) => handleTranslationSubmit(formData, isEdit)}
                    isLoading={loading.mutation.especes}
                />
            }
        </div>
    );
}

export default Espece;